export default __webpack_public_path__ + "static/media/0077ROUGE.a574f990.pdf";